import React from 'react';
import './Copyright.css';

const copyright = props => (
    <p className="copy">&copy; {new Date().getFullYear()} CampTheFork.com</p>
);

export default copyright;